var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',[_c('b-row',[_c('credential-plan-card',{attrs:{"client-data":_vm.clientData}}),_c('user-client-info',{attrs:{"client-data":_vm.clientData,"user-data":_vm.userData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }